import { useIntl } from "react-intl";
import { Occurrence } from "../../../models/occurrence";
import { getOccurrenceStepLabelByStepValue } from "../../../enums/occurrenceStep";

interface Props {
    mainOccurrenceData: Occurrence;
    onClear?: null | VoidFunction;
}

const MainOccurenceCard = ({ mainOccurrenceData, onClear }: Props) => {
    const intl = useIntl();

    const currentStep = mainOccurrenceData?.occurrenceSteps?.find((step) => !step.dtEnd);

    return (
        <div className="w-full mb-10 rounded-lg border border-gray-200 bg-white px-5 py-4 flex items-center justify-between shadow-sm">
            <div className="flex items-center gap-4">
                <div>
                    <p className="text-2lg font-bold">
                        {mainOccurrenceData?.model}
                    </p>

                    <p className="text-2lg">
                        {intl.formatMessage({ id: "intl-msg:tas.occurrence.chassis" })} - {mainOccurrenceData?.vehicleChassis}
                    </p>
                </div>
            </div>
            <div className="flex items-center gap-25">
                <div className="flex items-center gap-3">
                    <p className="text-2lg font-bold">{intl.formatMessage({ id: "intl-msg:tas.occurrence.contract" })}</p>
                    <p className="text-2lg font-bold">-</p>
                    <p className="text-2lg font-bold">
                        {mainOccurrenceData?.contractNumber || 'N/A'}
                    </p>
                </div>

                <div>
                    <div className="flex items-center gap-3">
                        <p className="text-2lg font-bold">{intl.formatMessage({ id: "intl-msg:tas.occurrence.occurrence" })}</p>
                        <p className="text-2lg font-bold">-</p>
                        <p className="text-2lg font-bold">
                            {mainOccurrenceData?.protocolNumber || 'N/A'}
                        </p>
                    </div>
                    <div className="flex items-center gap-3">
                        <p className="text-2lg font-bold">{intl.formatMessage({ id: "intl-msg:tas.occurrence.step" })}</p>
                        <p className="text-2lg font-bold">-</p>
                        <p className="text-2lg font-bold">
                            {currentStep?.stepId ? getOccurrenceStepLabelByStepValue(currentStep?.stepId) : 'Concluído'}
                        </p>
                    </div>
                </div>

                {onClear ? (
                    <div className="flex items-center gap-3">
                        <button
                            type="button"
                            aria-label={intl.formatMessage({ id: "intl-msg:tas.occurrence.unlink-occurrence" })}
                            title={intl.formatMessage({ id: "intl-msg:tas.occurrence.unlink-occurrence" })}
                            className="btn btn-link padding-0 text-color-gray"
                            onClick={onClear}
                        >
                            <span className="rioglyph rioglyph-remove-sign margin-0" />
                        </button>
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default MainOccurenceCard;